(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("manageQuestions", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/exams/manageQuestionsView.html",
            controller: ["examQuestionResource", "examCategoryQuestionResource", "messageService", "$sessionStorage", "$state", "$stateParams", "$timeout", "$translate", "DTOptionsBuilder", "DTColumnDefBuilder", "_", ManageQuestionsCtrl],
            controllerAs: "vm"
        };
        function ManageQuestionsCtrl(examQuestionResource, examCategoryQuestionResource, messageService, $sessionStorage, $state, $stateParams, $timeout, $translate, DTOptionsBuilder, DTColumnDefBuilder, _) {
            var vm = this;
            vm.dataLoaded = false;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.number = $stateParams.number;
            vm.dtInstance = {};
            vm.model = {
                questions: [],
                examCategories: []
            };
            vm.statuses = [{ "id": 0, "status": "common.draft" }, { "id": 1, "status": "common.enabled" }, { "id": 2, "status": "common.archived" }];
            vm.reloadTable = reloadTable;
            // ============================================================= //
            vm.$onInit = function () {
                if ($sessionStorage.manageExamQuestionsFilters) {
                    vm.filters = $sessionStorage.manageExamQuestionsFilters;
                }
                else {
                    vm.filters = {
                        question: { enabled: true, value: "" },
                        status: { enabled: true, value: [0, 1, 2] }
                    };
                }
                load();
            };
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", false)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("sort", false)
                .withOption("paging", false)
                .withBootstrap();
            function load() {
                if ($state.current.name === "main.learningItems.manageExamQuestions") {
                    vm.state = "manageExamQuestions";
                    vm.categoryNumber = "0";
                    examQuestionResource.getManageExamQuestionsViewModel({ number: vm.number }, function (model) {
                        vm.model = model;
                        filterQuestions();
                        vm.dataLoaded = true;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                else {
                    vm.state = "manageExamCategoryQuestions";
                    vm.categoryNumber = $stateParams.categoryNumber;
                    examCategoryQuestionResource.getManageExamQuestionsViewModel({ number: vm.number, categoryNumber: vm.categoryNumber }, function (model) {
                        vm.model = model;
                        filterQuestions();
                        var category = _.find(model.examCategories, { number: parseInt(vm.categoryNumber, 10) });
                        vm.breadCrumCategoryName = category.name;
                        vm.dataLoaded = true;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
            }
            function reloadTable() {
                $sessionStorage.manageExamQuestionsFilters = vm.filters;
                filterQuestions();
            }
            function filterQuestions() {
                vm.filteredQuestions = _.filter(vm.model.questions, function (question) {
                    var include = true;
                    if (vm.filters.question.value.length > 0) {
                        include = question.questionText.toLowerCase().includes(vm.filters.question.value.toLowerCase());
                    }
                    if (include) {
                        include = vm.filters.status.value.includes(question.statusId);
                    }
                    return include;
                });
                vm.showReorder = vm.filters.question.value.length === 0 && vm.filters.status.value.length == 3 && (vm.state === "manageExamCategoryQuestions" || vm.model.examCategories.length === 0);
            }
            vm.sortableOptions = {
                handle: ".fa-bars",
                //disabled: !vm.showReorder,
                axis: "y",
                stop: function () {
                    vm.updateOrder();
                }
            };
            vm.updateOrder = function () {
                vm.newOrder = [];
                for (var i = 1; i <= vm.filteredQuestions.length; i++) {
                    vm.filteredQuestions[i - 1].order = i;
                    vm.newOrder.push({
                        "number": vm.filteredQuestions[i - 1].number,
                        "order": vm.filteredQuestions[i - 1].order
                    });
                }
                examQuestionResource.reorderExamQuestions({ number: vm.number, examQuestions: vm.newOrder }, function () {
                    messageService.success("common.changesSaved");
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.editQuestion = function (question) {
                if (vm.categoryNumber === "0")
                    $state.go("main.learningItems.editExamQuestion", { number: vm.number, questionNumber: question.number });
                else
                    $state.go("main.learningItems.editExamCategoryQuestion", { number: vm.number, categoryNumber: vm.categoryNumber, questionNumber: question.number });
            };
            vm.selectCategory = function () {
                if (vm.categoryNumber === "0")
                    $state.go("main.learningItems.manageExamQuestions", { number: vm.number });
                else
                    $state.go("main.learningItems.manageExamCategoryQuestions", { number: vm.number, categoryNumber: vm.categoryNumber });
            };
            vm.goBack = function () {
                if (vm.categoryNumber === "0")
                    $state.go("main.learningItems.editExam", { number: vm.number });
                else
                    $state.go("main.learningItems.editExamCategory", { number: vm.number, categoryNumber: vm.categoryNumber });
            };
            vm.addQuestion = function () {
                if (vm.categoryNumber === "0")
                    $state.go("main.learningItems.addExamQuestion", { number: vm.number });
                else
                    $state.go("main.learningItems.addExamCategoryQuestion", { number: vm.number, categoryNumber: vm.categoryNumber });
            };
        }
    });
}());
